module.exports = __webpack_public_path__ + "assets/img/android-landscape.66e1747.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/android-landscape.png
// module id = Fedn
// module chunks = 50